<template>
  <component :is="view"/>
</template>

<script>
  import MobileView from "./MobileView";
  import DesktopView from "./DesktopView";

  export default {
    name: "index",
    components: {
      MobileView,
      DesktopView
    },
    data() {
      return {
        width: 0
      }
    },
    computed: {
      view() {
        return this.width < 1000 ? 'mobile-view' : 'desktop-view';
      }
    },
    methods: {
      resize() {
        this.width = document.body.clientWidth;
      }
    },
    mounted() {
      window && window.addEventListener('optimizedResize', () => {
        this.resize();
      })
      this.resize();
    }
  }
</script>

<style lang="scss" scoped>

</style>
